/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import React from 'react';

const riskColor = (risk) => {

  if (risk === 'Low') {
    return 'bg-green-100 text-green-700';
  }

  if (risk === 'Moderate') {
    return 'bg-yellow-100 text-yellow-700';
  }

  return 'bg-red-100 text-red-700';
};


const ConsistentFunds = ({ data }) => {

  return (

    <div className="bg-white rounded-3xl p-8 shadow-sm border">

      {/* HEADER */}
      <div className="flex justify-between items-center mb-8">

        <div>
          <h2 className="text-3xl font-bold text-gray-900">
            Most Consistent Funds
          </h2>

          <p className="text-gray-500 mt-2">
            Funds delivering stable long-term performance with controlled risk.
          </p>
        </div>

      </div>


      {/* GRID */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

        {data.map((fund, index) => (

          <div
            key={index}
            className="
              border border-gray-200
              rounded-3xl
              p-6
              hover:shadow-lg
              transition-all
              duration-300
              bg-white
            "
          >

            {/* TOP ROW */}
            <div className="flex items-start justify-between mb-5">

              {/* ICON + NAME */}
              <div className="flex items-center gap-4">

                <div
                  className="
                    w-14 h-14
                    rounded-2xl
                    bg-green-50
                    flex
                    items-center
                    justify-center
                    font-bold
                    text-green-700
                    text-lg
                  "
                >
                  {fund.scheme_name?.substring(0, 2).toUpperCase()}
                </div>

                <div>

                  <div className="font-bold text-lg text-gray-900 leading-snug">
                    {fund.scheme_name}
                  </div>

                  <div className="text-sm text-gray-500 mt-1">
                    {fund.sub_category}
                  </div>

                </div>

              </div>

            </div>


            {/* METRICS */}
            <div className="grid grid-cols-2 gap-5 mb-6">

              {/* 3Y RETURN */}
              <div
                className="
                  bg-gray-50
                  rounded-2xl
                  p-4
                "
              >

                <div className="text-sm text-gray-500 mb-2">
                  3Y Return
                </div>

                <div className="text-2xl font-bold text-green-700">
                  {fund.return_3y?.toFixed(2)}%
                </div>

              </div>


              {/* RISK */}
              <div
                className="
                  bg-gray-50
                  rounded-2xl
                  p-4
                "
              >

                <div className="text-sm text-gray-500 mb-2">
                  Risk Profile
                </div>

                <div>
                <span
                  className={
                    "px-4 py-2 rounded-full text-sm font-semibold " +
                    riskColor(fund.risk_grade)
                  }
                >
                  </span>
                </div>

              </div>

            </div>


            {/* FOOTER */}
            <div className="flex justify-between items-center">

              <div>

                <div className="text-sm text-gray-500">
                  Stability Score
                </div>

                <div className="font-semibold text-gray-800">
                  High Consistency
                </div>

              </div>

              <a href={`/mfd/${fund.isin}`}>
                <button
                  className="
                    bg-green-700
                    hover:bg-green-800
                    text-white
                    px-6
                    py-3
                    rounded-full
                    font-semibold
                    transition-all
                  "
                >
                  View
                </button>
              </a>
            </div>

          </div>

        ))}

      </div>

    </div>
  );
};

export default ConsistentFunds;